import { Header } from './styles';
import OpacityAnimation from '../../../../components/OpacityAnimation';
import { Dispatch, SetStateAction } from 'react';

interface ListHeaderInterface {
  doesListExists: boolean;
  hasError: boolean;
  filteredListLength: number;
  singularLabel: string;
  pluralLabel: string;
  setAddInternalUserModalShow: Dispatch<SetStateAction<boolean>>,
}

export default function ListHeader({
  doesListExists,
  hasError,
  filteredListLength,
  singularLabel,
  pluralLabel,
  setAddInternalUserModalShow,
}: ListHeaderInterface) {
  return (
    <OpacityAnimation delay={0.1}>
      <Header doesListExists={doesListExists} apiFetched={!hasError}>
        {(doesListExists) && (
          <div className="leftAlignment">
            <strong>
              {filteredListLength}
              {' '}
              {filteredListLength === 1 ? singularLabel : pluralLabel}
            </strong>
          </div>
        )}
        <div className="actionButtons">
          <button type="button" onClick={() => setAddInternalUserModalShow(true)}>Novo usuário</button>
        </div>
      </Header>
    </OpacityAnimation>
  );
}
